import { LoadAmbulatoryOrderDocument } from 'domain/usecases/ambulatory/load-ambulatory-order-document'
import { NewAmbulatoryRepository } from 'repository/interfaces/new-ambulatory-repository'

export class RemoteLoadAmbulatoryOrderDocument
  implements LoadAmbulatoryOrderDocument
{
  private readonly ambulatoryRepository: NewAmbulatoryRepository

  constructor(ambulatoryRepository: NewAmbulatoryRepository) {
    this.ambulatoryRepository = ambulatoryRepository
  }

  load(
    params: LoadAmbulatoryOrderDocument.Params
  ): Promise<LoadAmbulatoryOrderDocument.Model> {
    return this.ambulatoryRepository.loadAmbulatoryOrderDocument(params)
  }
}
